import React from "react";
import { motion } from "framer-motion";
import { FaGithub, FaLinkedin, FaEnvelope, FaPhone } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative pt-20 pb-10 overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-64 bg-accent/5 blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-2xl font-heading font-bold mb-2">
              <span className="bg-gradient-to-r from-accent to-neon-purple bg-clip-text text-transparent">Sayed</span>
              <span className="text-white">.dev</span>
            </h2>
            <p className="text-slate-400 text-sm mb-4">Mobile App Developer & UI/UX Enthusiast</p>
            <p className="text-slate-500 text-sm leading-relaxed">
              React Native Developer with 2+ years of experience building production-ready mobile applications.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h3 className="text-lg font-bold text-white mb-4">Quick Links</h3>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-slate-400 hover:text-accent transition-colors text-sm">Home</Link>
              <Link to="/projects" className="text-slate-400 hover:text-accent transition-colors text-sm">Projects</Link>
              <Link to="/experience" className="text-slate-400 hover:text-accent transition-colors text-sm">Experience</Link>
              <Link to="/contact" className="text-slate-400 hover:text-accent transition-colors text-sm">Contact</Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h3 className="text-lg font-bold text-white mb-4">Contact</h3>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:alihasanshah755@gmail.com"
                className="flex items-center gap-2 text-slate-400 hover:text-accent transition-colors text-sm"
              >
                <FaEnvelope size={14} />
                alihasanshah755@gmail.com
              </a>
              <a
                href="tel:+923480090755"
                className="flex items-center gap-2 text-slate-400 hover:text-accent transition-colors text-sm"
              >
                <FaPhone size={14} />
                +92 348 0090755
              </a>
            </div>
          </motion.div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex gap-4">
            <motion.a
              href="https://github.com/SayedHasanAliShah"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ y: -3, color: "#38bdf8" }}
              className="text-slate-400 text-xl transition-colors"
            >
              <FaGithub />
            </motion.a>
            <motion.a
              href="https://www.linkedin.com/in/sayed-hasan-ali-shah"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ y: -3, color: "#38bdf8" }}
              className="text-slate-400 text-xl transition-colors"
            >
              <FaLinkedin />
            </motion.a>
          </div>

          <div className="w-full max-w-xs h-px bg-gradient-to-r from-transparent via-white/10 to-transparent hidden md:block" />

          <p className="text-slate-500 text-xs text-center">
            © {currentYear} Sayed.dev. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
